import modelBaseV2 from "../../model-base-v2.model";

/**
 * Global Hierarchy Model
 * 
 * Contains all API Request used by Global Hierarchy
 * 
 * @author Darrus Goh
 */
const GlobalHierarchyModel = {
    getHierarchyTree: (hierarchyType, fromLevel, toLevel) => {
        const params = Object.assign({
            hierarchyType
        },
            fromLevel ? { fromLevel } : null,
            toLevel ? { toLevel } : null
        );

        return modelBaseV2.get('/api/codemaster/hierarchy/:hierarchyType', { params });
    },

    getHierarchyDetail: (hierarchyType, hierarchyCode) => {
        const params = {
            hierarchyType,
            hierarchyCode
        };

        return modelBaseV2.get('/api/codemaster/hierarchy/:hierarchyType/:hierarchyCode', { params });
    }
};

export default GlobalHierarchyModel;